module.exports = (__webpack_require__(40))("t/UT");